import { useContext, createContext } from 'react';
import { translations } from './translations';

// Create Translation Context
const TranslationContext = createContext();

// Translation Provider Component
export const TranslationProvider = ({ children, lang = 'en' }) => {
  const currentLang = lang === 'ar' ? 'ar' : 'en';
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[currentLang];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Fallback to English if translation not found
        value = translations.en;
        for (const fallbackKey of keys) {
          if (value && typeof value === 'object' && fallbackKey in value) {
            value = value[fallbackKey];
          } else {
            return key; // Return key if translation not found
          }
        }
        break;
      }
    }
    
    return typeof value === 'string' ? value : key;
  };

  return (
    <TranslationContext.Provider value={{ t, lang: currentLang }}>
      {children}
    </TranslationContext.Provider>
  );
};

// useTranslation Hook
export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    // Fallback if used outside provider
    return {
      t: (key) => key,
      lang: 'en'
    };
  }
  return context;
};

